import createReactClass from 'create-react-class';
'use strict';

import React    from 'react';
import ReactDOM from 'react-dom';

import genericHelpers from '../../_utils/generic-helpers';
import Spinner        from '../utils/spinner';

var LazyThumbnail = createReactClass({
  getInitialState() {
    return {
       loaded: false
     };
  },
  componentDidMount() {
    var debouncedOnWindowScroll = genericHelpers.debounce(this.onWindowScroll);
    $(ReactDOM.findDOMNode(this)).closest('.thumbnails').
                                  on('scroll', debouncedOnWindowScroll).
                                  on('resize', debouncedOnWindowScroll);

    this.onWindowScroll();
  },
  componentWillUnmount() {
    $(ReactDOM.findDOMNode(this)).closest('.thumbnails').off('scroll')
                                               .off('resize');
  },
  onWindowScroll() {
    var threshold = this.props.threshold || 300;

    var bounds    = ReactDOM.findDOMNode(this).getBoundingClientRect();
    var scrollTop = window.pageYOffset;
    var top       = bounds.top + scrollTop;
    var height    = bounds.bottom - bounds.top;

    var visible   = (top === 0 || (top <= (scrollTop + window.innerHeight + threshold)
                      && (top + height) > (scrollTop - threshold)));

    this.setState({
      loaded: visible
    });
  },

  render() {
    if (!this.state.loaded) {
      return (
        <div className="thumbnail_ placeholder">
          <Spinner />
        </div>
      );
    }

    return (
      <this.props.thumbnailType
        file={this.props.file}
        position={this.props.position}
        selected={this.props.selected}
        withOrientation={this.props.withOrientation}
        onErrorIconClick={this.props.onErrorIconClick}
        onImagePreviewError={this.props.onImagePreviewError}
        onRemoveThumbnail={this.props.onRemoveThumbnail}
        onSelect={this.props.onSelect}
        onUnSelect={this.props.onUnSelect}
        displayCaption={this.props.displayCaption}
      />
    );
  }
});

export default LazyThumbnail;
